import React from 'react';
import { CDIsotype, BrandWordmark } from './BrandMark';
type LogoProps = {
  showWordmark?: boolean;
  showTagline?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
const MARK_SIZE = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-14 w-14'
} as const;
export function Logo({
  showWordmark = true,
  showTagline = false,
  size = 'sm',
  className = ''
}: LogoProps) {
  return <a href="#inicio" aria-label="Creativo Digital — inicio" className={`group inline-flex items-center gap-3 transition-opacity duration-300 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30 focus-visible:ring-offset-4 focus-visible:ring-offset-[#0d0d0f] ${className}`} data-id="element-316" data-mp="mscmootpokwe">
      <CDIsotype className={MARK_SIZE[size]} data-id="element-317" data-mp="hs6osqwum25v" />
      {showWordmark && <>
          <span aria-hidden="true" className="h-7 w-px bg-white/12 group-hover:bg-white/20" data-id="element-318" data-mp="2yhlyfthl31kr" />
          <BrandWordmark size={size} showTagline={showTagline} data-id="element-319" data-mp="32lbhy4jeisyx" />
        </>}
    </a>;
}